import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { Router } from "@angular/router";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/typeahead-match.class";

@Component({
  selector: "app-cancel-noshow",
  templateUrl: "./cancel-noshow.component.html",
})
export class CancelNoshowComponent implements OnInit {
  patientList: any = [];
  selectedPatientId = "";
  cancelledList = [];
  noShowList = [];
  path: any;
  selectedPatientIdByUrl = "";
  selectedName = "";
  activetab: any;

  constructor(private appservice: AppService, private router: Router) {}

  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 4) {
      this.selectedPatientIdByUrl = Splitpath[3];
    }

    this.getPatientList();
    this.getPatientDataCancelled(this.selectedPatientIdByUrl);
    this.getPatientDataNoShow(this.selectedPatientIdByUrl);

    if (
      sessionStorage.getItem("cancelornoshowtab") &&
      sessionStorage.getItem("cancelornoshowtab") === "noshowtab"
    ) {
      this.activetab = "noshowtab";
    } else {
      this.activetab = "canceltab";
    }
  }

  getPatientList() {
    const data = {
      tcId: localStorage.getItem("testCenterId"),
    };
    this.appservice.getAllPatientByTcId(data).subscribe((patient: any) => {
      if (patient.status.status === 200) {
        this.patientList = patient.entity;
        if (this.patientList.length > 0) {
          this.patientList.forEach((patientData) => {
            patientData.username =
              patientData.firstName + " " + patientData.lastName;
          });
        }
      }
    });
  }

  refreshAll() {
    this.selectedName = "";
    this.selectedPatientId = "";
    this.getPatientDataCancelled(this.selectedPatientId);
    this.getPatientDataNoShow(this.selectedPatientId);
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedPatientId = event.item.id;
    this.getPatientDataCancelled(this.selectedPatientId);
    this.getPatientDataNoShow(this.selectedPatientId);
  }

  getPatientDataCancelled(id) {
    const data = {
      patientId: id,
      tcId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
    };
    this.appservice.getPatientCancelData(data).subscribe((res: any) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.cancelledList = res["entity"];
      } else {
        this.cancelledList = [];
      }
    });
  }

  getPatientDataNoShow(id) {
    const data = {
      patientId: id,
      tcId: localStorage.getItem("testCenterId"),
      pageNumber: 0,
      pageSize: 0,
    };
    this.appservice.getPatientNoShowData(data).subscribe((res: any) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.noShowList = res["entity"];
      } else {
        this.noShowList = [];
      }
    });
  }
}
